<template>
  <el-row :class="['unknown-or-copy', { 'ta-c': middle }]">
    <p v-if="type === 'copy'" class="mb-30">
      Если Вы уверены, что это копия ранее<br />
      сохраненного файла, пометьте файл как<br />
      обработанный и переходите к следующему
    </p>
    <template v-else>
      <p>
        Сохраните файл на диск и передайте<br />
        ответственному сотруднику
      </p>
      <el-row type="flex" :justify="middle ? 'center' : 'start'" class="mb-30">
        <i class="el-icon-download fs-30" />
        <el-button type="text" class="td-u ml-10" @click="handleDownload">
          Скачать файл
        </el-button>
      </el-row>
      <p v-if="!middle">И после переходите к следующему файлу</p>
    </template>
    <el-button type="success" plain @click="handleSorted">
      Пометить как обработанный и перейти к новому файлу
    </el-button>
  </el-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UnknownOrCopy',
  props: {
    type: {
      type: String,
      default: '',
    },
    middle: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('hardware', ['current']),
  },
  methods: {
    ...mapActions('hardware', ['generateZipUrl', 'makeDocSorted']),
    async handleDownload() {
      const path = await this.generateZipUrl(this.current.document_id)

      this.downloadRegistry({ path, blank: 1 })
    },
    handleSorted() {
      const document_type_id = this.getDocumentTypeIdByType('document_sorted')

      this.makeDocSorted({
        id: this.current.document_id,
        data: { document_type_id },
      })
    },
  },
}
</script>

<style lang="sass">
.unknown-or-copy
  .fs-30
    font-size: 30px
  .ml-10
    margin-left: 10px
  .mb-30
    margin-bottom: 30px
</style>
